import React from 'react';
import StakeholderInfo from '../../../../../components/Forms/stakeholder/info';

function CADDStakeholderInfo() {
  return <StakeholderInfo module="cadd" view="scp" drawerTitle= "Edit supply chain participant"/>
};

export default CADDStakeholderInfo;
